const monthNames = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']

export const getMonth = date => monthNames[date.getMonth()]

export const getDayMonth = date => `${date.getDate()} ${getMonth(date)}`
